// JOBE-0158.3: StatusPill — lightly-tinted status indicator.
// Four original tones: ok / warn / bad (colored border+text, lightly tinted bg, small dot)
// and pencil (dashed border, no dot — "not-run" / disabled state, screen-guide.md §W7).
//
// Four lifecycle tones (JOBE-0158.3-followup, 2026-05-24): active / superseded /
// tombstoned / candidate — for W8 memory-row lifecycle states (screen-guide.md §W8,
// decisions.md D17). superseded and tombstoned carry strikethrough per
// design-system.md §"Disabled / superseded".
//
// Do NOT collapse with the existing .pill selector in styles.css. That is a
// separate component using ink-on-paper. Migration of existing consumers to
// StatusPill is JOBE-0158-followup.

import './StatusPill.css';

const TONE_CLASS = {
  ok: 'status-pill--ok',
  warn: 'status-pill--warn',
  bad: 'status-pill--bad',
  pencil: 'status-pill--pencil',
  // W8 lifecycle tones
  active: 'status-pill--active',
  superseded: 'status-pill--superseded',
  tombstoned: 'status-pill--tombstoned',
  candidate: 'status-pill--candidate',
};

/** Tones that show a leading dot */
const TONES_WITH_DOT = new Set(['ok', 'warn', 'bad', 'active']);

/** Tones whose label is rendered with strikethrough */
const TONES_WITH_STRIKETHROUGH = new Set(['superseded', 'tombstoned']);

/**
 * @param {object} props
 * @param {'ok'|'warn'|'bad'|'pencil'|'active'|'superseded'|'tombstoned'|'candidate'} props.tone
 * @param {string} props.label
 */
export function StatusPill({ tone, label }) {
  const hasDot = TONES_WITH_DOT.has(tone);
  const hasStrikethrough = TONES_WITH_STRIKETHROUGH.has(tone);
  return (
    <span className={['status-pill', TONE_CLASS[tone]].filter(Boolean).join(' ')}>
      {hasDot && <span className="status-pill__dot" aria-hidden="true" />}
      <span className="status-pill__label">
        {hasStrikethrough ? <s>{label}</s> : label}
      </span>
    </span>
  );
}
